import controller from './cart.controller';
import template from './cart.view.html';

let CartComponent = {
  template,
  controller,
  bindings : {
    shCtrl : '<'
  }
};

export default CartComponent;



/** WEBPACK FOOTER **
 ** C:/xampp/htdocs/payomaro-pay-zone/www/components/cart/cart.component.js
 **/